import { render, staticRenderFns } from "./PrincipalPage.vue?vue&type=template&id=d51898d8&scoped=true"
import script from "./PrincipalPage.js?vue&type=script&lang=js&external"
export * from "./PrincipalPage.js?vue&type=script&lang=js&external"
import style0 from "./PrincipalPage.vue?vue&type=style&index=0&id=d51898d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51898d8",
  null
  
)

export default component.exports